<template>
  <div>
    <!-- 主表表单 -->
    <a-form style="margin-top: 8px" :form="form">
      <j-form-container :disabled="online_form_disabled">
        <online-form-item :properties="rootProperties" :comFn="createWidgets" slot="detail" />
        <slot name="formItem"></slot>
      </j-form-container>
    </a-form>
    <!-- 子表 -->
    <a-tabs v-model="subActiveKey" v-if="hasTab">
      <a-tab-pane v-for="(sub,index) in subTabInfo" :tab="sub.describe" :key="index" :forceRender="true">
        <div style="overflow-y:auto;overflow-x:hidden;max-height: 300px;" v-if="sub.relationType == 1">
          <j-form-container :disabled="online_form_disabled">
            <online-sub-form slot="detail"
                             :ref="sub.key"
                             :main-id="model.id"
                             :table="sub.key"
                             :properties="subProperties[sub.key]"
                             @formChange="arg=>handleSubFormChange(arg, sub.key)"
                             @executeFillRule="handleSubFormExecuteFillRule(sub.key)" />
          </j-form-container>
        </div>
        <j-vxe-table v-else
                     :ref="sub.key"
                     :key="subKey"
                     :toolbar="setToolShow(sub.key)"
                     :excludeBtn="excludeBtn[sub.key]"
                     keep-source
                     row-number
                     row-selection
                     :subSchema="sub"
                     height="auto"
                     :maxHeight="488"
                     :disabled="online_form_disabled"
                     :columns="sub.columns"
                     :dataSource="subDataSource[sub.key]"
                     :customButton="customButton[sub.key]"
                     @customerButtonClick="customerButtonClick"
                     @valueChange="event=>handleValueChange(event, sub.key)"
                     @added="handleAdded"
                     :authPre="getSubTableAuthPre(sub.key)"
                     @executeFillRule="handleExecuteFillRuleSub(sub, $event)">
        </j-vxe-table>
      </a-tab-pane>
    </a-tabs>
    <div style="width: 100%;text-align: center;margin-top:5px" v-if="showFooter">
      <a-button icon="check" style="width: 126px" type="primary" @click="handleSubmit" :loading="submitLoading">
        提交
      </a-button>
    </div>
    <!-- 跳转Href的动态组件方式 -->
    <j-modal v-bind="hrefComponent.model" v-on="hrefComponent.on" dialogClass="jeecg-online-modal">
      <component ref="dynamicComp" :is="hrefComponent.is" v-bind="hrefComponent.params" />
    </j-modal>
  </div>
</template>

<script>
import OnlineFormItem from './OnlineFormItem.vue'
import OnlineSubForm from './OnlineSubForm.vue'
import FormProperty from './model/FormProperty'
import pick from 'lodash.pick'
import debounce from 'lodash/debounce'
import { getUploadFileList, getFilePaths } from './model/UploadFile'
import { httpAction, getAction, postAction, deleteAction } from '@/api/manage'
import { getRefPromise, validateFormAndTables, VALIDATE_FAILED } from '@/components/jeecg/JVxeTable/utils/vxeUtils.js'
import { duplicateCheck, listByBizId } from '@/api/api'
import { onlUtil } from '@/mixins/OnlineCommonUtil'
import lodash_object from 'lodash'
import { loadFieldDefVal, loadFieldDefValForSubTable, ACTION_TYPES } from '@comp/online/autoform/model/FieldDefVal'
import { getVmParentByName, keyUpListener, simpleDebounce } from '@/utils/util'
import { addOnlineBtAuth2Storage } from '@/utils/authFilter'
import { mapGetters } from 'vuex'
import { getLanguageField, resetLangFieldMap, setLangInputParams } from '@/utils/langUtils'
import { WIDGET_PRE } from '@comp/online/autoform/model/Constants'
import widgetRegistry from '@comp/online/autoform/model/WidgetRegistry'
import onlineFormEnhance from '@comp/online/autoform/mixins/onlineFormEnhance'
import moment from 'moment'

export default {
  name: 'OnlineForm',
  mixins: [onlUtil, onlineFormEnhance],
  components: {
    OnlineFormItem,
    OnlineSubForm
  },
  provide() {
    return {
      sh: this.sh,
      // 公用JS增强方法
      getUtilEnhanceJS: () => this.utilEnhanceJS,
      // form组件的ref
      getForm: () => this.form,
      // 编辑时获取到的数据
      getDetailData: () => this.form.getFieldsValue()
    }
  },
  data() {
    return {
      // 表单变化开关变量
      flag: 1,
      // 当前模态框类型add、edit、detail
      actionType: '',
      // 子表列表按钮配置
      excludeBtn: {},
      // 子表JS增强方法
      subEnhanceJS: {},
      // 子表中是否启用数据多语言字段
      subLangField: [],
      // 子表组件key，用于重新渲染
      subKey: 0,
      form: this.$form.createForm(this, { 'onValuesChange': this.onValuesChange }),
      online_form_disabled: false,
      // 是否展示子表列表上的工具栏
      subToolbar: {},
      lodash: lodash_object,
      rootProperties: [],
      subProperties: {},
      aaaca: [],
      subTabInfo: [],
      subDataSource: {},
      // 子表自定义按钮自定义js
      customButton: {},
      submitLoading: false,
      model: {},
      showFields: [],
      fileFields: [],
      url: '',
      optionUrl: '/online/cgform/api/querySelectOptions',
      urlButtonAction: '/online/cgform/api/doButton',
      submitMethod: '',
      hasTab: false,
      EnhanceJs: '',
      immediateEnhance: false,
      sh: {},
      tablename: '',
      //树形列表的信息保存
      treeListExpandKeys: [],
      // 一对多子表Tab的Key，用于校验未通过时自动跳转
      subActiveKey: 0,
      // popup选中的数据
      popupSelected: {},
      // 当前点击调用方法的自定义按钮code
      buttonCode: {},
      // 模态框参数
      hrefComponent: {
        model: {
          title: '选择',
          width: '50%',
          visible: false,
          destroyOnClose: true,
          confirmLoading: false,
          style: {
            top: 0,
            left: 0,
            margin: 0,
            padding: 0
          },
          bodyStyle: {
            padding: '20px',
            maxHeight: 'calc(80vh - 108px)',
            overflowY: 'auto',
            overflowX: 'hidden'
          }
        },
        on: {
          ok: () => this.submitModal(),
          cancel: () => this.cancelModal()
        },
        is: null,
        params: {}
      }
    }
  },
  props: {
    formSchema: {
      type: Object,
      default: () => {
      },
      required: true
    },
    uiSchema: {
      type: Object,
      default: () => {
      },
      required: true
    },
    showFooter: {
      type: Boolean,
      default: false,
      required: false
    },
    single: {
      type: Boolean,
      default: true,
      required: false
    },
    tree: {
      type: Boolean,
      default: false,
      required: false
    },
    enhanceStr: {
      type: String,
      default: '',
      required: false
    },
    tableType: {
      type: Number,
      required: false,
      default: 1
    },
    oa: {
      type: Boolean,
      default: false,
      required: false
    },
    // 当modal组件嵌套在主表下的时候，主表的数据
    mainData: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    ...mapGetters(['tableLangField', 'tableLangMap'])
  },
  beforeDestroy() {
    this.$bus.$off('popupCallbackMinitor')
  },
  created() {
    //TODO 如果觉得BUS不合适可以使用vuex
    this.treeListExpandKeys = []
    this.$bus.$on('popupCallbackMinitor', (row, selected) => {
      this.popupSelected = {
        ...this.popupSelected,
        ...selected
      }
      if (row) {
        if (row.type === 'treeListAddEvent') {
          this.treeListExpandKeys = row.expandedRowKeys
        } else {
          this.form.setFieldsValue(row)
        }
      }
    })
    document.onkeydown = e => keyUpListener(this.form.domFields, e)
  },
  mounted() {
    this.createRootProperties()
  },
  methods: {
    moment,
    ...mapGetters(['langFieldMap']),
    // 初始化主表表单项和子表组件
    createRootProperties() {
      this.tablename = this.formSchema.table
      const properties = this.formSchema.properties
      const formTemplate = this.uiSchema.formTemplate
      let rootProperties = [], subInfo = []
      let subDataSourceKeys = []
      Object.keys(properties).map((key) => {
        const item = {
          ...properties[ key ],
          key,
        }
        const uiItem = this.uiSchema[ key ]
        // 子表处理
        if (item.view == 'tab') {
          subInfo.push(item)
          this.getInitUtilEnhanceJs(() => {
            // 获取子表数据多语言信息
            this.getLangItem(item.key)
            this.getSubCgButton(item)
          })
          // 一对一
          if (item.relationType == 1) {
            this.initSubProperties(item, key)
          } else {
            //如果是一对多子表处理单选组件改为下拉框
            this.dealSubProerties(item)
            subDataSourceKeys.push({ key, order: item.order })
            //处理子表的新增删除按钮权限
            this.handleSubTableButtonAuth(item)
          }
        } else {
          this.$set(this.sh, key, true)
          this.$set(this.sh, key + '_load', true)
          // 初始化主表默认表单项attr配置对象
          if (!item.ui) item.ui = { widgetattrs: {} }
          let fp = new FormProperty(key, { tableName: this.tablename, ...item }, uiItem, this.formSchema.required, formTemplate, this.formSchema)
          fp.checkOnlyMethod = debounce(this.checkOnlyFieldValue, 1000)
          rootProperties.push(fp)
        }
      })
      // update--begin--author:sunjianlei-----date:20200313------for：使 subDataSource 的顺序和 subTabInfo 的顺序保持一致 ------
      this.subDataSource = {}
      subDataSourceKeys.sort((one, next) => one.order - next.order).forEach(item => {
        this.$set(this.subDataSource, item.key, [])
      })
      // update--end--author:sunjianlei-----date:20200313------for：使 subDataSource 的顺序和 subTabInfo 的顺序保持一致 ------
      rootProperties.sort((one, next) => {
        return one.formSchema.order - next.formSchema.order
      })
      this.rootProperties = [...rootProperties]
      if (subInfo.length) {
        subInfo.sort((one, next) => {
          return one.order - next.order
        })
        this.subTabInfo = [...subInfo]
        this.hasTab = true
      } else {
        this.hasTab = false
        this.subTabInfo = []
      }
      //设置pca组件的位置
      this.pcaOptionPositionSetting()
      // 加载组件默认值
      this.loadMainFieldDefVal(ACTION_TYPES.ADD)
    },
    // 创建表单项组件方法
    createWidgets(formItem) {
      let key = WIDGET_PRE + formItem.type
      return widgetRegistry.getType(key)
    },
    // 获取子表自定义按钮和自定义js
    getSubCgButton({ id, key }) {
      let url = '/online/cgform/api/getColumns/'
      getAction(url + id).then(res => {
        let data = res.result
        this.customButton[ key ] = {
          // 自定义按钮数组
          cgButtonList: data.cgButtonList,
          // js增强
          enhanceJs: data.enhanceJs
        }
        this.initSubCgEnhanceJs(key, data.enhanceJs)
        this.subKey++
      })
    },
    // 初始化子表的JS增强方法
    initSubCgEnhanceJs(subKey = this.getSubKey(), enhanceJs) {
      if (!enhanceJs) return
      let Obj = eval(`(${enhanceJs})`)
      this.subEnhanceJS[ subKey ] = new Obj(getAction, postAction, deleteAction)
    },
    // 子表按钮执行js增强中的方法
    subButtonJsHandler(buttonCode, backData) {
      let subKey = this.subTabInfo[ this.subActiveKey ].key
      let jsEnhance = this.subEnhanceJS[ subKey ]
      if (jsEnhance) {
        if (jsEnhance[ buttonCode ]) jsEnhance[ buttonCode ](this, backData)
      }
    },
    // 获取多语言字段 relEntityAttribute
    getLangItem(relTable) {
      relTable && getLanguageField(relTable).then(res => {
        this.subLangField = res.fieldArr
        this.$store.commit('SET_SUBLANGFIELD', this.subLangField)
      })
    },
    // 获取列表数据多语言信息
    getDataLang(data) {
      if (!data || !data.length) return []
      let ids = data?.map(ele => ele.id)
      let bizIds = ids.toString()
      return bizIds && listByBizId({ bizIds }).then(res => {
        const result = res.result
        if (!result || !result.length) return []
        return result
      })
    },
    // 初始化子表信息
    initSubProperties(formSchema, tbname) {
      const formTemplate = this.uiSchema.formTemplate
      let subProperties = []
      let showOrHidden = {}
      Object.keys(formSchema.properties).map((key) => {
        const item = formSchema.properties[ key ]
        showOrHidden[ key ] = true
        showOrHidden[ key + '_load' ] = true
        let fp = new FormProperty(key, item, '', formSchema.required, formTemplate)
        fp.subKey = tbname
        subProperties.push(fp)
      })
      // 设置一对一时子表表单项显示隐藏
      this.$set(this.sh, tbname, showOrHidden)
      subProperties.sort((one, next) => {
        return one.formSchema.order - next.formSchema.order
      })
      this.subProperties[ tbname ] = subProperties
      this.aaaca = [...subProperties]
    },
    add(param) {
      this.flag = 1
      this.actionType = 'add'
      this.show()
      this.model = {}
      Object.keys(this.subDataSource).forEach(key => {
        this.$set(this.subDataSource, key, [])
      })
      this.$nextTick(() => {
        if (param) {
          this.form.setFieldsValue(param)
        }
        this.initFileFieldsValue({})
        this.immediateEnhance = true
        this.loaded()
      })
      // 加载组件默认值
      this.loadMainFieldDefVal(ACTION_TYPES.ADD)
    },
    edit(record) {
      this.flag = 1
      this.actionType = 'edit'
      this.initFormData(record).then(() => {
        this.immediateEnhance = true
        this.loaded()
      })
      this.loadMainFieldDefVal(ACTION_TYPES.EDIT)
    },
    detail(record) {
      this.flag = 1
      this.actionType = 'detail'
      this.initFormData(record).then(() => {
        this.immediateEnhance = true
        this.online_form_disabled = true
        this.loaded()
      })
    },
    // 子表是否展示工具栏配置
    setToolShow(key) {
      let str = this.subToolbar[ key ]
      if (!str) return true
      return str === 'hide'? false: true
    },
    // 执行JS增强中的loaded方法
    loaded() {
      if (this.enhanceStr) {
        this.cgButtonJsHandler('loaded')
      }
    },
    // 根据数据id和字段code获取多语言信息
    getLangListById(id, field) {
      let mainLang = this.$ls.get('language') || 'zh-cn'
      let langObj = this.tableLangMap
      if (!langObj[ `${id},${field}` ]) return ''
      return langObj[ `${id},${field}` ]?.find(lang => lang.langType === mainLang)?.langText || ''
    },
    initFormData(record) {
      let mainLang = this.$ls.get('language') || 'zh-cn'
      return new Promise((resolve) => {
        this.show(record)
        this.model = Object.assign({}, record)
        this.$nextTick(() => {
          // 主表表单字段设置数据多语言值
          this.tableLangField.forEach(item => {
            let newValue = this.getLangListById(this.model.id, item)
            if (newValue) this.model[ item ] = newValue
          })
          this.form.setFieldsValue(pick(this.model, ...this.showFields))
          this.initFileFieldsValue(record)
          Object.keys(this.subDataSource).forEach(async key => {
            // 获取各个子表的数据多语言信息
            if (!this.model[ key ]) return
            let languageList = await this.getDataLang(this.model[ key ])
            let list = this.model[ key ]
            // 子表列表数据多语言转换
            let listData = list.map(ele => {
              let sysLanguageList = languageList.filter(k => k.relBizId === ele.id)
              // 根据子表开启数据多语言字段设置值
              this.subLangField.forEach(item => {
                let newValue = sysLanguageList.find(k => k.langType === mainLang)?.langText
                if (newValue) ele[ item ] = newValue
              })
              return {
                ...ele,
                sysLanguageList
              }
            })
            this.$set(this.subDataSource, key, listData)
          })
          resolve()
        })
      })
    },
    show(rd) {
      this.clearForm()
      this.url = this.uiSchema.url
      this.submitMethod = this.uiSchema.method
      let currFormShowFields = [], currFileFields = []
      const properties = this.formSchema.properties
      let link_down_flag = false
      Object.keys(properties).forEach(function(key) {
        const item = properties[ key ]
        if (item.view == 'link_down') {
          link_down_flag = true
          return true
          /*if(item.others && item.others.length>0){
            for(let other of item.others){
              currFormShowFields.push(other.field)
            }
          }*/
        }
        if (item.view.indexOf('upload') >= 0 || item.view.indexOf('file') >= 0 || item.view.indexOf('image') >= 0) {
          currFileFields.push(key)
        } else if (!item.hidden) {
          if (item.view != 'tab') {
            currFormShowFields.push(key)
          }
        }
      })
      // 联动下拉框自动加载下拉框数据
      if (rd && link_down_flag === true) {
        this.$bus.$emit('formInitDataSuccess', rd)
      }
      this.showFields = [...currFormShowFields]
      this.fileFields = [...currFileFields]
      if (this.enhanceStr) {
        let Obj = eval(`(${this.enhanceStr})`)
        this.EnhanceJS = new Obj(getAction, postAction, deleteAction)
        // 为了让详情中自动触发JS增强中主表字段值改变后调用的方法
        this.immediateEnhance = true
        this.cgButtonJsHandler('show', rd, this.actionType)
      }
    },
    clearForm() {
      this.online_form_disabled = false
      this.form.resetFields()
      this.model = {}
      this.showFields = []
      this.fileFields = []
      this.immediateEnhance = false
      this.subActiveKey = 0
    },
    initFileFieldsValue(record) {
      if (this.fileFields && this.fileFields.length > 0) {
        for (var a = 0; a < this.fileFields.length; a++) {
          let fieldKey = this.fileFields[ a ]
          let fileVal = {}
          fileVal[ fieldKey ] = getUploadFileList(record[ fieldKey ])
          this.form.setFieldsValue(fileVal)
        }
      }
    },
    transFileListToString(values) {
      if (this.fileFields && this.fileFields.length > 0) {
        for (var a = 0; a < this.fileFields.length; a++) {
          let fieldKey = this.fileFields[ a ]
          let path = getFilePaths(values[ fieldKey ])
          values[ fieldKey ] = path
        }
      }
    },
    handleSubmit() {
      // 判断是单表还是主子表保存
      this.single? this.handleSingleSubmit(): this.handleOne2ManySubmit()
    },
    //处理js增强 自定义 提交前事件
    customBeforeSubmit(formData) {
      if (this.EnhanceJS && this.EnhanceJS[ 'beforeSubmit' ]) {
        return this.EnhanceJS[ 'beforeSubmit' ](this, formData, this.mainData)
      } else {
        return Promise.resolve()
      }
    },
    //发起请求
    doApplyRequest(formData) {
      Object.keys(formData).map(key => {
        if (Array.isArray(formData[ key ])) {
          if (formData[ key ].length == 0) {
            formData[ key ] = ''
          }
        }
      })
      let url = this.url + '?tabletype=' + this.tableType
      formData.sysLanguageList = setLangInputParams(this.tablename, formData.id)
      httpAction(url, formData, this.submitMethod).then((res) => {
        if (res.success) {
          resetLangFieldMap()
          if (res.result) {
            formData[ 'flow_submit_id' ] = res.result
          }
          if (this.tree === true) {
            this.$emit('onSuccess', formData, this.treeListExpandKeys)
          } else {
            this.$emit('onSuccess', formData)
          }
          if (this.oa === false) {
            this.$message.success(res.message)
          }
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    //提交数据前 先走一下自定义的JS校验
    handleApplyRequest(formData) {
      this.customBeforeSubmit(formData).then(() => {
        this.doApplyRequest(formData)
      }).catch(msg => {
        this.$message.warning(msg)
      })
    },
    getHandleRefs(arr) {
      let arr2 = []
      if (arr && arr.length > 0) {
        arr.forEach(item => {
          if (Array.isArray(item)) {
            arr2.push(item[ 0 ])
          } else {
            arr2.push(item)
          }
        })
      }
      return arr2
    },
    handleOne2ManySubmit() {
      // 校验主表和一对多
      this.getAllSubFormOrTable().then(tables => {
        let arr = this.getHandleRefs(tables)
        if (arr && arr.length > 0) {
          return validateFormAndTables(this.form, arr)
        } else {
          return new Promise((resolve, reject) => {
            this.form.validateFields((err, values) => {
              err? reject(): resolve({ 'formValue': values })
            })
          })
        }
      }).then(allValues => {
        let formData = Object.assign({}, this.model, allValues.formValue)
        this.transFileListToString(formData)
        if (allValues.tablesValue) {
          let keys = Object.keys(this.subDataSource)
          for (let i = 0; i < keys.length; i++) {
            formData[ keys[ i ] ] = allValues.tablesValue[ i ].tableData
          }
        }
        return Promise.resolve(formData)
      }).then((formData) => {
        // 校验一对一
        this.getAllSubFormOrTable(1).then(forms => {
          let needForms = this.getHandleRefs(forms)
          if (needForms && needForms.length > 0) {
            return this.validFormsCust(needForms, formData)
          } else {
            return Promise.resolve(formData)
          }
        }).then(formData => {
          console.log('----提交的表单数据为----', formData)
          this.handleApplyRequest(formData)
        }).catch((e) => {
          // 校验失败，捕获一下异常，防止控制台报错
        })
      }).catch(e => {
        if (e && e.error === VALIDATE_FAILED) {
          if (typeof e.index === 'number') {
            this.subActiveKey = e.paneKey || e.index
            console.warn(`Online第个${e.index + 1}子表未校验通过`)
          } else {
            console.warn('Online主表未校验通过')
          }
        } else {
          console.error(e)
        }
      })
    },
    handleSingleSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.transFileListToString(values)
          let formData = Object.assign({}, this.model, values)
          this.handleApplyRequest(formData)
        }
      })
    },
    // 获取所有的一对一表单或一对多行编辑
    getAllSubFormOrTable(arg) {
      let arr = []
      const that = this
      for (let i of that.subTabInfo) {
        if (arg == 1) {
          // 一对一
          if (i.relationType == 1) {
            arr.push(getRefPromise(that, i.key))
          }
        } else {
          // 一对多
          if (i.relationType != 1) {
            arr.push(getRefPromise(that, i.key))
          }
        }
      }
      return Promise.all(arr)
    },
    handleValueChange(event, tableKey) {
      if (this.EnhanceJS && this.EnhanceJS[ tableKey + '_onlChange' ]) {
        let tableChangeObj = this.EnhanceJS[ tableKey + '_onlChange' ]()
        if (tableChangeObj[ event.column.key ]) {
          tableChangeObj[ event.column.key ](this, event)
        }
      }
    },
    //处理一对一子表的表单改变事件
    handleSubFormChange(valueObj, tableKey) {
      if (this.EnhanceJS && this.EnhanceJS[ tableKey + '_onlChange' ]) {
        let tableChangeObj = this.EnhanceJS[ tableKey + '_onlChange' ]()
        let columnKey = Object.keys(valueObj)[ 0 ]
        if (tableChangeObj[ columnKey ]) {
          let subRef = this.$refs[ tableKey ]
          if (subRef instanceof Array) {
            subRef = subRef[ 0 ]
          }
          let formEvent = subRef.getFormEvent()
          let event = {
            column: { key: columnKey },
            value: valueObj[ columnKey ],
            ...formEvent
          }
          tableChangeObj[ columnKey ](this, event)
        }
      }
    },
    cgButtonJsHandler(buttonCode, data, type) {
      if (this.EnhanceJS && this.EnhanceJS[ buttonCode ]) {
        this.EnhanceJS[ buttonCode ](this, data, type)
      }
    },
    // 主表表单值改变调用方法
    onValuesChange(v, valueObj) {
      if (!this.EnhanceJS || !this.EnhanceJS[ 'onlChange' ] || this.immediateEnhance === false) {
        return false
      }
      /*
      * valueObj:  { name: 4 }
      * columnKey   当前发生改变表单项的字段
      * */
      if (!valueObj) return false
      let columnKey = Object.keys(valueObj)
      if (!columnKey.length) return false
      this.getInitUtilEnhanceJs(() => {
        columnKey.forEach(ele => {
          this.fieldValueChange(ele, valueObj)
        })
      })
      if(this.actionType !== 'detail') {
        debounce(() => this.flag++, 8000)()
      }
    },
    // 主表字段值改变调用JS增强中的方法
    fieldValueChange(columnKey, valueObj) {
      if (!columnKey) return false
      let value = valueObj[ columnKey ]
      // 初始化获取JS增强中的方法
      let tableChangeObj = this.EnhanceJS[ 'onlChange' ]()
      if (tableChangeObj[ columnKey ]) {
        let event = {
          row: this.form.getFieldsValue(),
          column: { key: columnKey },
          value: value
        }
        tableChangeObj[ columnKey ](this, event)
      }
    },
    handleCgButtonClick(optType, buttonCode, cgConfigId) {
      if ('js' == optType) {
        if (this.EnhanceJS[ buttonCode ]) {
          this.EnhanceJS[ buttonCode ](this)
        }
      } else if ('action' == optType) {
        let params = {
          formId: cgConfigId,
          buttonCode: buttonCode,
          dataId: this.model.id,
          uiFormData: Object.assign({}, this.model, this.form.getFieldsValue())
        }
        console.log('自定义按钮请求后台参数：', params)
        postAction(this.urlButtonAction, params).then(res => {
          if (res.success) {
            this.$message.success('处理完成!')
          } else {
            this.$message.warning('处理失败!')
          }
        })

      }
    },
    checkOnlyFieldValue(rule, value, callback) {
      if (!value) {
        callback()
      }
      //对于视图 需要将表名后的$+数字 取掉
      let realTableName = this.tablename.replace(/\$\d+/, '')
      let param = {
        tableName: realTableName,
        fieldName: rule.field,
        fieldVal: value
      }
      if (this.model.id) {
        param.dataId = this.model.id
      }
      //console.log("校验checkOnlyFieldValue---》",param)
      duplicateCheck(param).then((res) => {
        if (res.success) {
          callback()
        } else {
          callback(res.message)
        }
      })
    },
    validFormsCust(formRefs, formdata) {
      let _this = this
      return new Promise((resolve, reject) => {
        let index = 0;
        (function next() {
          let vm = formRefs[ index ]
          vm.getAll().then(all => {
            Object.assign(formdata, all)
            if (++index === formRefs.length) {
              resolve(formdata)
            } else {
              (
                next()
              )
            }
          }, error => {
            reject(error)
            // 尝试切换Tab
            let tabPane = getVmParentByName(vm, 'ATabPane')
            if (tabPane) {
              _this.subActiveKey = tabPane.$vnode.key
            }
          })
        })()
      })
    },
    // 主表表单设置默认值
    loadMainFieldDefVal(action) {
      this.setMainSelectDefVal()
      let params = {
        form: this.form,
        properties: this.rootProperties,
        action: action,
        getFormData: () => this.form.getFieldsValue()
      }
      // 设置默认值的是联动下拉框类型的时候需要暴露回调函数进行联动下拉框数据加载
      loadFieldDefVal(params, () => {
        let data = this.form.getFieldsValue()
        this.$bus.$emit('formInitDataSuccess', data)
      })
    },
    // 主表表单设置下拉框第一项为默认值
    setMainSelectDefVal() {
      this.rootProperties.forEach(item => {
        let { key, view } = item._formSchem
        let options = item._formSchem.enum
        if(view === 'list' && options && options.length === 1) {
          let value = options[0].value || ''
          this.form.setFieldsValue({ [key]: value })
        }
      })
    },
    loadSubFieldDefVal(subForms, subTable, row, action) {
      loadFieldDefValForSubTable({
        subForms: subForms,
        subTable: subTable,
        row: row,
        action: action,
        getFormData: () => {
          let sub = {}
          if (subForms.form) {
            sub = subForms.form.getFieldsValue()
          } else {
            sub = subForms.jvt.getTableData({ rowIds: [row.id] })[ 0 ]
          }
          return { main: this.form.getFieldsValue(), sub: sub }
        }
      })
    },
    // 当行编辑新增完成后触发的事件
    handleAdded(event) {
      event.target.$emit('executeFillRule', event)
    },
    handleExecuteFillRuleSub(subTable, event) {
      let { row, form, target } = event
      this.loadSubFieldDefVal({ jvt: target, form }, subTable, row, ACTION_TYPES.ADD)
    },
    // 子表表单设置默认值
    handleSubFormExecuteFillRule(key) {
      let form = this.$refs[ key ][ 0 ].form
      loadFieldDefVal({
        form: form,
        properties: this.subProperties[ key ],
        action: ACTION_TYPES.ADD,
        getFormData: () => form.getFieldsValue()
      })
    },
    // 设置外键的值 这个很重要
    setForeignKeysValue(obj) {
      //console.log("外键的值",obj)
      this.$nextTick(() => {
        this.form.setFieldsValue(obj)
      })
    },
    pcaOptionPositionSetting() {
      this.$nextTick(() => {
        let getOffsetTopByBody = (el) => {
          let offsetTop = 0
          while (el && el.tagName !== 'BODY') {
            offsetTop += el.offsetLeft
            el = el.offsetParent
          }
          return offsetTop
        }
        setTimeout(() => {
          let obj = document.getElementById('pca')
          if (obj) {
            let modal = document.querySelector('.jeecg-online-modal')
            let num = Number(getOffsetTopByBody(obj)) - Number(getOffsetTopByBody(modal)) + 480 - Number(modal.offsetWidth)
            if (num > 0) {
              document.querySelector(' #pca .cascader-menu-list-wrap').style.left = (0 - num - 10) + 'px'
              document.querySelector(' #pca .cascader-menu-list-wrap').style.top = '30px'
            }
          }
        }, 1000)
      })
    },
    //一对多子表如果为单选按钮改为下拉框
    dealSubProerties(subInfo) {
      subInfo.columns.forEach(column => {
        if (column.type === 'radio') {
          column.type = 'select'
        }
      })
    },
    getSubTableAuthPre(table) {
      return 'online_' + table + ':'
    },
    handleSubTableButtonAuth(item) {
      let pre = 'online_' + item.key + ':'
      addOnlineBtAuth2Storage(pre, item.hideButtons)
    },
    // 模态框点确认
    submitModal() {
      let detailData = this.getSelected()
      this.customerButtonClick({
        button: { buttonCode: this.buttonCode },
        detailData
      })
      this.hrefComponent.model.visible = false
    },
    // 关闭模态框
    cancelModal() {
      this.hrefComponent.model.visible = false
    },
    // 获取自定义按钮打开的动态popup组件选中的数据
    getSelected() {
      return this.$refs.dynamicComp.getData()
    }
  }
}
</script>
